
import { Box } from '@mui/material';
import React, { useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';

function Banner() {
  const [text, setText] = useState('');
  return (
    <Box className="banner" >
      {/* Video element */}
      <Box className="videoBox">
      <video autoPlay muted loop style={{ width: '100%', height: '100%', objectFit: 'cover' }}>
        <source src="/assets/banner.mp4" type="video/mp4" />
        <source src="/assets/banner.ogg" type="video/ogg" />
       
      </video>
      <Box className="BannerText">
        <h1>Mapping Sacred <br /> Architecture Together</h1>
        <p>Discover amazing temples <br /> wherever you go</p>
        
        <Box className="searchBox">
          <input type="text" placeholder="Search Destination" value={text} onChange={(e) => setText(e.target.value)} className="form-control " />
          <Box className='searchIcon'>
          <SearchIcon  />
          </Box>
        </Box>
      </Box>
      </Box>
      {/* Optionally, you can add overlay content like text or buttons */}
      
    </Box>
  );
}

export default Banner;
